var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgLinux = function SvgLinux(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 24c0 11.592-9.398 21-21 21S3 35.592 3 24C3 12.398 12.398 3 24 3s21 9.398 21 21Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.96 32.865c-.188-.28-.352-.658-.486-1.11-2.41-2.718-.548-6.717 1.294-9.433.176-.29.369-.572.578-.84 1.405-1.745 1.768-2.96 1.876-4.604.013-.306-.012-.71-.041-1.176-.149-2.376-.396-6.324 3.844-6.674 5.299-.438 4.867 4.429 4.828 7.282l-.004.344c-.015 1.72.883 2.897 1.82 4.126.342.45.69.905 1 1.396l.027.044c1.637 2.361 3.254 5.885 1.004 9.228-.316 1.14-.795 2.188-1.434 3.04-2.295 3.02-4.334 2.713-5.927 2.474-.48-.072-.92-.139-1.314-.105-.655.04-1.18.145-1.632.237-1.751.353-2.435.491-5.433-4.229Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.021 11.692c-.049 1.398-1.532 2.613-3.31 2.726-1.78.112-3.174-.95-3.125-2.348.049-1.4 1.533-2.614 3.31-2.726 1.78-.102 3.174.95 3.125 2.348Z",
    fill: "url(#linux_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.798 15.091c.015.76.363 1.41.852 1.702-1.596-.143-3.573.44-3.573 1.545-.025 1.867-1.064 4.191-1.813 5.864-.147.33-.283.634-.398.904-.463 1.147-.741 2.374-.774 3.577-1.227-1.69-.335-3.86.145-4.802.64-1.239.628-1.394.38-1.103-.953 1.62-2.747 4.872-.5 6.826a6.99 6.99 0 0 0 .66 2.495c3.007 6.064 8.637 3.573 10.494.429.247-.447.447-.88.606-1.298.093.059.192.104.298.134.933.276 2.329-.776 2.663-1.43.403-.867-.01-1.459-1.386-2.163a5.555 5.555 0 0 0-.208-.098c.528-2.222-.926-4.532-1.964-5.512-.194-.047-.22.062.08.362.654.627 2.076 2.861 1.306 4.94a2.494 2.494 0 0 0-.365-.07c-.236-1.42-.866-2.523-1.307-3.294-.1-.175-.19-.333-.263-.473a17.217 17.217 0 0 0-.514-.888c-.724-1.199-1.608-2.662-1.608-4.829-.111-.477-.561-.795-1.16-.97.695-.14 1.217-.953 1.199-1.93-.02-1.05-.678-1.888-1.464-1.867-.786.02-1.415.898-1.386 1.95Zm.649.235c-.01.582.265 1.052.629 1.052.354 0 .658-.47.668-1.042.01-.582-.265-1.051-.629-1.051-.363 0-.658.47-.668 1.041Z",
    fill: "url(#linux_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.833 16.725c.57-.03.983-.797.934-1.705-.05-.909-.55-1.613-1.12-1.582-.57.03-.983.796-.934 1.704.05.909.55 1.613 1.12 1.583Zm.344-1.389c.05.48-.128.888-.383.93-.255.03-.501-.327-.55-.807-.05-.48.128-.888.383-.93.256-.03.501.328.55.807Z",
    fill: "url(#linux_svg__c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.595 15c-.03.326.117.592.324.612.206.02.403-.235.432-.551.03-.327-.118-.592-.324-.613-.206-.02-.403.235-.432.552Z",
    fill: "url(#linux_svg__d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.961 15.081c.03.266-.079.5-.236.521-.157.02-.304-.184-.334-.46-.03-.265.079-.5.236-.52.157-.02.305.194.334.46Z",
    fill: "url(#linux_svg__e)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.004 25.729c0 1.797-1.66 4.124-4.51 4.104-2.938.02-4.185-2.307-4.185-4.104 0-1.797 1.945-3.257 4.342-3.257 2.408.01 4.353 1.46 4.353 3.257Z",
    fill: "url(#linux_svg__f)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.451 20.084c-.03 1.858-1.198 2.297-2.672 2.297-1.474 0-2.545-.276-2.673-2.297 0-1.266 1.2-2 2.673-2 1.474-.011 2.672.724 2.672 2Z",
    fill: "url(#linux_svg__g)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 22.942c.963-1.521 2.996-3.859.383.327-2.122 3.45-.786 5.666-.098 6.278 1.984 1.838 1.906 3.073.344 2.103-3.35-2.072-2.653-5.564-.63-8.708Z",
    fill: "url(#linux_svg__h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.482 23.565c-.835-1.786-3.488-6.319.128-1.051 3.29 4.767.982 8.085.57 8.412-.413.326-1.799.99-1.396-.164.413-1.153 2.456-3.338.698-7.197Z",
    fill: "url(#linux_svg__i)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.813 37.653c-2.201-1.215-5.394.235-4.235-3.053.236-.745-.344-1.868.03-2.593.441-.888 1.395-.694 1.964-1.286.56-.612.914-1.674 1.966-1.51 1.041.163 1.739 1.49 2.466 3.123.54 1.164 2.446 2.807 2.318 4.114-.157 2.001-2.348 2.379-4.51 1.205Z",
    fill: "url(#linux_svg__j)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.815 30.96c-.535.586-1.518.446-1.913 1.212-.253.492.024 1.247.061 1.786.046.666-.505 1.608-.224 2.177.315.638 1.74.555 2.367.647 1.547.226 4.103 2.228 5.502.63 1.368-1.562-1.26-3.538-1.905-4.927-.42-.942-1.047-2.747-2.215-2.931-.823-.128-1.198.888-1.673 1.407Zm1.772-2.093c1.455.228 2.182 2.113 2.72 3.319.814 1.748 3.605 3.627 1.796 5.694-1.643 1.877-4.237-.14-6.09-.41-.925-.135-2.385-.038-2.87-1.018-.416-.842.211-1.605.153-2.444-.05-.715-.332-1.483.016-2.162.476-.954 1.396-.723 2.021-1.367.664-.73 1.062-1.797 2.254-1.612Z",
    fill: "#E68C3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.071 37.092c1.612-2.032 5.198-1.613 2.78-4.4-.51-.603-.353-1.889-.982-2.44-.736-.674-1.552-.123-2.299-.47-.747-.378-1.532-1.102-2.446-.592-.914.52-1.012 1.868-1.1 3.645-.08 1.276-1.2 3.41-.6 4.583.865 1.818 3.115 1.573 4.647-.326Z",
    fill: "url(#linux_svg__k)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.715 29.547c.413-.01.908.019 1.373.442.578.51.584 1.341.801 2.038.259.825 1.163 1.296 1.109 2.263-.089 1.58-2.826 1.962-3.67 3.024-.81 1.003-1.833 1.6-2.804 1.681-1.473.122-2.69-1.116-2.604-2.629.07-1.224.694-2.337.77-3.551.043-.88.09-1.695.25-2.357.16-.67.45-1.246 1.023-1.572 1.256-.702 2.469.695 3.752.662Zm-3.432-.051c-.34.194-.556.552-.694 1.13-.14.585-.187 1.335-.232 2.231-.075 1.218-.7 2.33-.77 3.55-.061 1.09.775 1.987 1.884 1.896.752-.063 1.62-.538 2.343-1.433.646-.814 3.457-1.57 3.516-2.62.038-.687-.865-1.33-1.076-2.008-.166-.53-.175-1.352-.6-1.724-.272-.248-.557-.285-.922-.276-1.057.028-2.467-1.293-3.448-.746Z",
    fill: "#E68C3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.374 34.376c2.496-3.828.639-3.797.01-4.093-.63-.307-1.287-.909-2.024-.49-.737.428-.776 1.53-.796 2.98-.03 1.042-.865 2.787-.364 3.757.61 1.133 2.083-.51 3.174-2.154Z",
    fill: "url(#linux_svg__l)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 34.927c-3.734-2.511-1.985-3.369-1.425-3.767.678-.51.688-1.49 1.523-1.399.835.092 1.326 1.164 1.887 2.491.412.95 1.847 2.216 1.739 3.308-.138 1.286-2.113.439-3.724-.633Z",
    fill: "url(#linux_svg__m)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.622 29.904c-.295.531-1.494 1.369-2.29 1.144-.815-.214-1.189-1.409-1.021-2.307.147-1.021 1.021-1.072 2.122-.562 1.17.552 1.533 1.021 1.189 1.726Z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.816 29.608c-.186.368-.973.95-1.523.797-.55-.154-.825-.98-.737-1.603.079-.705.668-.745 1.415-.398.806.388 1.061.714.845 1.204Z",
    fill: "url(#linux_svg__n)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.657 16.286c.393-.377 1.346-1.531 3.154-.326.334.224.609.245 1.247.53 1.287.552.678 1.879-.697 2.328-.59.194-1.12.94-2.181.868-.914-.051-1.15-.674-1.71-1.01-.992-.583-1.14-1.369-.6-1.787.54-.419.747-.572.787-.603Z",
    fill: "url(#linux_svg__o)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.99 17.055a.532.532 0 0 0-.202.605c.14.48 1.145 1.142 1.53 1.465.22.184.47.33.875.352.867.059 1.348-.608 2.108-.858.5-.163 1.556-.787 1.206-1.501-.299-.61-1.305-.648-1.805-.984-.86-.573-1.487-.569-1.933-.408-.489.176-1.335.986-1.778 1.33Zm1.647-1.723c.58-.21 1.335-.18 2.283.452.622.418 1.57.378 1.945 1.144.478.977-.681 1.84-1.444 2.088-.816.27-1.273.943-2.253.877a1.768 1.768 0 0 1-1.102-.444c-.554-.465-1.49-.907-1.705-1.645-.118-.41.055-.824.39-1.083.541-.42 1.273-1.168 1.886-1.389Z",
    fill: "#E68C3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.211 17.35a.137.137 0 0 1-.126.147c-1.04.059-1.77 1.246-2.945 1.246-.657 0-1.177-.317-1.55-.622-.074-.062-.735-.572-.735-.701 0-.077.06-.14.133-.14.138 0 .555.453.71.58.35.287.871.605 1.442.605 1.163 0 1.876-1.186 2.93-1.246a.136.136 0 0 1 .141.132Z",
    fill: "#E68C3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.266 16.184c.196-.184.815-.684 1.63-.174.178.102.354.214.61.368.52.316.265.776-.364 1.061-.285.123-.756.388-1.11.368-.393-.041-.658-.306-.914-.48-.481-.327-.452-.602-.226-.817.167-.163.354-.316.374-.326Z",
    fill: "url(#linux_svg__p)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__a",
    x1: 24.087,
    y1: 9.459,
    x2: 23.755,
    y2: 13.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__b",
    x1: 19.345,
    y1: 34.008,
    x2: 16.876,
    y2: 25.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__c",
    x1: 19.345,
    y1: 34.008,
    x2: 16.876,
    y2: 25.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__d",
    x1: 25.003,
    y1: 14.483,
    x2: 24.863,
    y2: 15.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__e",
    x1: 21.651,
    y1: 14.674,
    x2: 21.801,
    y2: 15.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__f",
    x1: 23.642,
    y1: 23.446,
    x2: 23.667,
    y2: 29.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__g",
    x1: 23.775,
    y1: 19.687,
    x2: 23.803,
    y2: 22.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__h",
    x1: 17.579,
    y1: 21.158,
    x2: 17.579,
    y2: 29.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__i",
    x1: 31.549,
    y1: 20.304,
    x2: 31.546,
    y2: 28.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__j",
    x1: 17.142,
    y1: 33.656,
    x2: 15.802,
    y2: 38.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__k",
    x1: 29.822,
    y1: 32.295,
    x2: 33.398,
    y2: 37.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__l",
    x1: 30.78,
    y1: 28.4,
    x2: 29.53,
    y2: 34.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__m",
    x1: 16.869,
    y1: 29.856,
    x2: 17.117,
    y2: 36.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__n",
    x1: 30.563,
    y1: 28.292,
    x2: 30.853,
    y2: 30.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__o",
    x1: 23.647,
    y1: 16.176,
    x2: 23.671,
    y2: 19.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux_svg__p",
    x1: 23.265,
    y1: 15.845,
    x2: 23.259,
    y2: 17.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgLinux;